import React              from 'react';
import { Button }         from 'antd';
import { UnlockOutlined } from '@ant-design/icons';
import { LockFilled }     from '@ant-design/icons';
import Input              from '@widesk-ui/components/form/Input';
import { InputProps }     from '@widesk-ui/components/form/Input';

export default function InputLock(props: InputProps & { isLocked?: boolean, onLockedChange?: (locked: boolean) => void }) {
	const [locked, setLocked] = React.useState(props.isLocked);

	const handleLockToggle = () => {
		setLocked(!locked);

		if (props.onLockedChange) {
			props.onLockedChange(!locked);
		}
	};

	return (
		<Input
			disabled={locked}
			suffix={(
				<Button
					type="link"
					size={props.size}
					icon={locked ? <LockFilled /> : <UnlockOutlined />}
					onClick={handleLockToggle}
					style={{ height: '100%' }}
				/>
			)}

			{...props}
		/>
	);
}
